import {
    AUTOCOMPLETE_COMMUNITY_LABELS_REQUEST,
    AUTOCOMPLETE_COMMUNITY_SYSTEM_LABELS_REQUEST,
    AUTOCOMPLETE_USERS_WITH_EMAIL_REQUEST,
    AUTOCOMPLETE_CONCEPTS_REQUEST,
    AUTOCOMPLETE_PROJECTS_REQUEST,
    AUTOCOMPLETE_SOURCES_REQUEST,
    AUTOCOMPLETE_REQUEST,
    AUTOCOMPLETE_RESPONSE,
    AUTOCOMPLETE_ERROR_RESPONSE
} from "./action-types"

export const autocompleteRequest = (
    type,
    entityType,
    searchTerm,
    callback,
    callbackActionCreator
) => ({
    type,
    entityType,
    searchTerm,
    callback,
    callbackActionCreator
})

export const autocompleteEntityRequest = (
    entityType,
    searchTerm,
    callback,
    callbackActionCreator
) =>
    autocompleteRequest(
        AUTOCOMPLETE_REQUEST,
        entityType,
        searchTerm,
        callback,
        callbackActionCreator
    )

export const autocompleteTopicsRequest = (searchTerm, callback) =>
    autocompleteEntityRequest({ Topic: "all" }, searchTerm, callback)
export const autocompleteDimensionsRequest = (searchTerm, callback) =>
    autocompleteEntityRequest({ Dimension: "all" }, searchTerm, callback)
export const autocompleteTopicsAndDimensionsRequest = (searchTerm, callback) =>
    autocompleteEntityRequest(
        [{ Dimension: "all" }, { Topic: "all" }],
        searchTerm,
        callback
    )
export const autocompletePermissionGroupsRequest = (searchTerm, callback) =>
    autocompleteEntityRequest("PermissionGroup", searchTerm, callback)
export const autocompleteCommunitiesRequest = (searchTerm, callback) =>
    autocompleteEntityRequest({ Community: "all" }, searchTerm, callback)
export const autocompleteUsersRequest = (searchTerm, callback) =>
    autocompleteEntityRequest({ User: "all" }, searchTerm, callback)
export const autocompleteEmailRequest = (searchTerm, callback) =>
    autocompleteEntityRequest({ Email: "all" }, searchTerm, callback)
export const autocompleteOwnerViewerRequest = (
    searchTerm,
    callback,
    callbackActionCreator
) =>
    autocompleteEntityRequest(
        [{ User: "all" }, { Organization: "owner" }, { Community: "owner" }],
        searchTerm,
        callback,
        callbackActionCreator
    )

export const autocompleteAttachmentProviderRequest = (
    searchTerm,
    callback,
    callbackActionCreator
) =>
    autocompleteEntityRequest(
        [
            { User: "current_user" },
            { Organization: "owner" },
            { Community: "owner" }
        ],
        searchTerm,
        callback,
        callbackActionCreator
    )

export const autocompleteSourcesRequest = (searchTerm, callback) =>
    autocompleteRequest(
        AUTOCOMPLETE_SOURCES_REQUEST,
        null,
        searchTerm,
        callback
    )

export const autocompleteProjectsRequest = (searchTerm, callback) =>
    autocompleteRequest(
        AUTOCOMPLETE_PROJECTS_REQUEST,
        null,
        searchTerm,
        callback
    )

export const autocompleteUsersWithEmailRequest = (searchTerm, callback) =>
    autocompleteRequest(
        AUTOCOMPLETE_USERS_WITH_EMAIL_REQUEST,
        null,
        searchTerm,
        callback
    )

export const autocompleteCommunityLabelsRequest = (searchTerm, callback) =>
    autocompleteRequest(
        AUTOCOMPLETE_COMMUNITY_LABELS_REQUEST,
        null,
        searchTerm,
        callback
    )

export const autocompleteCommunitySystemLabelsRequest = (
    searchTerm,
    callback
) =>
    autocompleteRequest(
        AUTOCOMPLETE_COMMUNITY_SYSTEM_LABELS_REQUEST,
        null,
        searchTerm,
        callback
    )

export const autocompleteConceptsRequest = (searchTerm, callback) =>
    autocompleteRequest(
        AUTOCOMPLETE_CONCEPTS_REQUEST,
        null,
        searchTerm,
        callback
    )

export const autocompleteResponse = (
    data,
    entityType,
    searchTerm,
    callbackActionCreator
) => ({
    type: AUTOCOMPLETE_RESPONSE,
    data,
    entityType,
    searchTerm,
    callbackActionCreator
})

export const autocompleteErrorResponse = (error, entityType, searchTerm) => ({
    type: AUTOCOMPLETE_ERROR_RESPONSE,
    error,
    entityType,
    searchTerm
})
